// @format
export enum Endpoint {
  AddHostName = 'addhostname',
  SetForceSSL = 'setforcessl',
  AddCertificate = 'addcertificate',
  AddBlockedIP = 'addblockedip',
  RemoveBlockedIP = 'removeblockedip',
  LoadFreeCertificate = 'loadfreecertificate',
  DeleteHostName = 'deleteHostname',
  PurgeCache = 'purgeCache',
  ApplyCode = 'applyCode',
  Purge = 'purge',
}
